export default __webpack_public_path__ + "static/media/bp3.cb9bdb1e.jpg";